import { Check } from "lucide-react";
import { ABOUT_POINTS } from "@/content/site";
import { Portrait } from "@/components/Portrait";
import { Reveal } from "@/components/Reveal";

export const About = () => {
  return (
    <section id="o-mne" data-testid="about-section" className="py-24 md:py-32 border-t border-[#F0F0F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-start">
          <Reveal className="order-2 lg:order-1 flex lg:justify-start justify-center">
            <Portrait size="small" src="/images/daniel-pekar-omne.webp" width={840} height={1118} />
          </Reveal>
          <Reveal delay={0.1} className="order-1 lg:order-2">
            <p className="flex items-center gap-4 text-xs uppercase tracking-[0.25em] text-[#737373] font-medium">
              <span className="w-10 h-[1px] bg-[#B69A58]" aria-hidden="true" />
              O mně
            </p>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl tracking-tight leading-[1.15] text-[#252525] mt-6">
              Poradenství, které začíná rozhovorem
            </h2>
            <p className="text-base md:text-lg text-[#4A4A4A] leading-relaxed text-justify mt-8">
              Jmenuji se Daniel Pekař a do světa finančního poradenství jsem vstoupil v roce 2014.
              Pět let jsem klientům pomáhal s hypotékami, úvěry, investicemi i pojištěním.
              Poté jsem se vydal jiným směrem a dnes na své zkušenosti znovu navazuji.
            </p>
            <p className="text-base md:text-lg text-[#4A4A4A] leading-relaxed text-justify mt-4">
              Věřím, že dobré poradenství začíná tím, že vám někdo naslouchá. Proto mě nejdřív
              zajímá vaše situace, potřeby a plány. Teprve potom společně hledáme vhodné řešení.
            </p>
            <p className="text-base md:text-lg text-[#4A4A4A] leading-relaxed text-justify mt-4">
              Jsem samostatný zprostředkovatel{" "}
              <a
                href="https://www.cnb.cz/cnb/jerrs"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="about-cnb-register"
                className="underline underline-offset-2 decoration-[#B69A58] hover:text-[#B69A58] transition-colors duration-300"
              >
                v evidenci ČNB
              </a>{" "}
              a spolupracuji s M&M Finance
              (skupina M&M Reality). Odbornou způsobilost pro distribuci životního i neživotního
              pojištění mám ověřenou odbornou zkouškou EFPA ČR. Působím v Ústí nad Labem —
              osobně, po dohodě v regionu i online po celé ČR.
            </p>
            <p className="text-base md:text-lg text-[#4A4A4A] leading-relaxed text-justify mt-4">
              Věřím, že dobré pojištění poznáte jednoduše: rozumíte mu, odpovídá vašemu životu
              a ve chvíli, kdy ho potřebujete, funguje.
            </p>
            <p className="font-display italic text-xl text-[#252525] mt-10" data-testid="about-signature">
              Daniel Pekař
            </p>
          </Reveal>
        </div>

        <ul className="mt-10 lg:mt-20 border-t border-[#F0F0F0] pt-8 lg:pt-12 grid grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-x-8 lg:gap-y-10" data-testid="about-points">
          {ABOUT_POINTS.map((point, i) => (
            <li key={point.title} className="border border-[#F0F0F0] p-4 lg:border-0 lg:p-0">
              <Reveal delay={i * 0.18}>
                <Check className="h-4 w-4 lg:h-5 lg:w-5 text-[#B69A58]" strokeWidth={1.5} aria-hidden="true" />
                <h3 className="text-sm lg:text-base font-medium text-[#252525] mt-2 lg:mt-4">{point.title}</h3>
                <p className="text-xs lg:text-sm text-[#4A4A4A] leading-snug lg:leading-relaxed mt-1.5 lg:mt-2">{point.text}</p>
              </Reveal>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
